<template>
    <div>
        <div class="page_title gradient_overlay" style="background: url(/assets/images/page_title_bg.jpg);">
            <div class="container">
                <div class="inner">
                    <h1 v-lang.restaurants></h1>
                    <ol class="breadcrumb">
                        <li>
                            <router-link to="/" v-lang.inicio></router-link>
                        </li>
                        <li v-lang.restaurants></li>
                    </ol>
                </div>
            </div>
        </div>
        <main id="room_page">
            <div class="container">
                <div class="row">
                    <div class="col-md-8">
                        <img v-bind:src="imagen_destacada" alt="" class="img-responsive">

                        <div class="main_title mt50" v-if="restaurant!=null">
                            <h2>{{ restaurant.name[currentLanguage] }}</h2>
                        </div>

                        <div v-if="restaurant!=null">
                            {{ restaurant.description[currentLanguage] }}
                        </div>

                    </div>
                    <div class="col-md-4">
                        <div class="sidebar">
                            <aside class="widget">
                                <help></help>
                            </aside>
                            <aside class="widget">
                                <last-posts></last-posts>
                            </aside>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    let _ = require('lodash');
    let HelpUs = require('../singleRoom/widgets/help.vue');
    let LastsPosts = require('../singleRoom/widgets/lastPosts.vue');
    export default
    {
        props : [],
        data : function()
        {
            return {
                restaurants : [],
                restaurant : null
            }
        },
        components : {
            help : HelpUs,
            'last-posts' : LastsPosts
        },
        created : function()
        {
            let self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
                if( self.$store.getters.config!=null )
                {
                    self.restaurants = self.$store.getters.config.restaurants;
                    self.restaurant = _.find( self.restaurants, function(item){
                        return item.id == self.$route.params.id;
                    });
                }
            });
            this.$store.watch( (state)=> {return this.$store.getters.config; }, (val) => {
                self.restaurants = self.$store.getters.config.restaurants;
                self.restaurant = _.find( self.restaurants, function(item){
                    return item.id == self.$route.params.id;
                });
            });
        },
        mounted : function(){
            let self = this;
            if( !_.isNull(self.$store.getters.config) )
            {
                self.restaurants = self.$store.getters.config.restaurants;
                self.restaurant = _.find( self.restaurants, function(item){
                    return item.id == self.$route.params.id;
                });
            }
        },
        computed : {
            currentLanguage : function(){
                return this.$language;
            },
            imagen_destacada : function(){
                if( !_.isNull(this.restaurant) && 'gallery' in this.restaurant && !_.isNull(this.restaurant.gallery) && 'photos' in this.restaurant.gallery )
                {
                    return this.restaurant.gallery.photos[0].large;
                }
                return '/assets/img/default_restaurant.jpg';
            },
        }
    }
</script>

<style>
    .margin-bottom-10
    {
        margin-bottom: 10px;
    }
    .icon-green
    {
        color: #82b73a !important;
    }
    .icon-red
    {
        color: #f1572f!important;
    }

</style>


// WEBPACK FOOTER //
// Single.vue?28238ce2